import { createTextComponent } from './createTextComponent';

export const H2 = createTextComponent({
  styleAs: 'h2',
  tag: 'h2',
});
